import React, {useEffect, useState} from 'react';
import _ from "lodash";
import AddEditCampaign from "./add-edit-campaign";
import CampaignFilters from "./campaign-filters";
import {searchCampaignsWithSearchCriteria} from "../../services/facebook-campaign-data.service";
import ShowProgressSpinner from "../../../common/ui/show-progress-spinner";
import ShowEmptyListMessage from "../../../design/components/common/show-empty-list-message";
import {CAMPAIGN_FIELDS_LIST} from "../../constants/campaign.constant";
import GoToLink from "../../../common/ui/go-to-link";
import CopyDataToClipboard from "../../../common/ui/copy-data-to-clipboard";

const defaultFilterCriteria: any = {};

const CampaignsList = () => {
    const [campaignsList, setCampaignsList] = useState(null);
    const [filterCriteria, setFilterCriteria] = useState(defaultFilterCriteria);
    const [dataFetchInProgress, setDataFetchInProgress] = useState(true);

    const getCampaignList = async () => {
        setDataFetchInProgress(true);

        const searchCriteriaList = [];

        let limitPerPage = 10;
        if (filterCriteria?.limit) {
            limitPerPage = filterCriteria?.limit;
        }

        _.forIn(filterCriteria, (value, attribute) => {
            if (attribute !== 'limit' && (!_.isEmpty(value) || value === true) && value !== 'EMPTY') {
                searchCriteriaList.push({field: attribute, condition: '==', value: value});
            }
        });

        const campaignListResult = await searchCampaignsWithSearchCriteria(searchCriteriaList, limitPerPage);

        setCampaignsList(campaignListResult);
        setDataFetchInProgress(false);
    }

    useEffect(() => {
        getCampaignList();
    }, [filterCriteria]);

    const refreshCampaignList = async () => {
        await getCampaignList();
    }

    return (
        <>

            <div className="flex justify-between">

                <div className="flex justify-start items-center mt-2 -ml-2 mb-2 w-full">
                    <div className={'text-xl ml-2 mr-4'}>
                        Campaign
                    </div>

                    <CampaignFilters
                        filterCriteria={filterCriteria}
                        setFilterCriteria={setFilterCriteria}/>

                    <div className="ml-4">
                        <ShowProgressSpinner dataFetchInProgress={dataFetchInProgress}/>
                    </div>
                </div>

                <div className="text-center w-1/6 flex items-center justify-end">
                    <div className="ml-2">
                        <AddEditCampaign
                            isAddCampaign={true}
                            refreshCampaignList={refreshCampaignList}/>
                    </div>
                </div>

            </div>

            <div className="flex justify-start">

                <div
                    className="w-full bg-white mt-4">

                    <ShowEmptyListMessage
                        dataList={campaignsList}
                        dataFetchInProgress={dataFetchInProgress}
                        label={'Campaigns'}/>

                    {campaignsList?.length > 0 &&
                        <table className="w-full">
                            <thead className="">
                            <tr>
                                <th className="p-2 border border-gray-400 bg-gray-400 text-white w-12">S.No</th>
                                {CAMPAIGN_FIELDS_LIST?.map((campaignField, rowIndex) => (
                                    <th key={`th-${rowIndex}`}
                                        className={`p-2 border border-gray-400 bg-gray-400 text-white text-left pl-2 ${campaignField?.cssClass}`}>{campaignField?.label}</th>
                                ))}
                                <th className="p-2 border border-gray-400 bg-gray-400 text-white w-64">
                                    Actions
                                </th>
                            </tr>
                            </thead>
                            <tbody className="">
                            {campaignsList?.map((campaign, rowIndex) => (
                                <tr key={`row-${rowIndex}`} className="border border-gray-400">
                                    <td className="p-2 border border-gray-400 m-auto">
                                        <div className="flex justify-center w-12">
                                            {rowIndex + 1}
                                        </div>
                                    </td>

                                    {CAMPAIGN_FIELDS_LIST?.map((campaignField, columnIndex) => (
                                        <React.Fragment key={`column-${rowIndex}-${columnIndex}`}>
                                            <td className={`p-2 border border-gray-400 m-auto ${campaignField?.cssClass}`}>
                                                {campaignField?.optionsMap &&
                                                    <>{campaignField?.optionsMap[campaign[campaignField?.attribute]]?.name}</>
                                                }

                                                {!campaignField?.optionsMap &&
                                                    <>
                                                        {campaign[campaignField?.attribute]}

                                                        {campaignField?.secondaryAttribute &&
                                                            <div className={'text-gray-500 text-sm'}>
                                                                {campaign[campaignField?.secondaryAttribute]}
                                                            </div>
                                                        }

                                                        {campaignField?.secondaryAttributes && campaign[campaignField?.secondaryAttributes[0]] &&
                                                            <div>
                                                                {campaignField?.secondaryAttributes?.map((secondaryAttribute, secondaryAttributeIndex) => (
                                                                    <React.Fragment
                                                                        key={`secondary-attribute-${secondaryAttributeIndex}`}>
                                                                        {campaign[secondaryAttribute] &&
                                                                            <span
                                                                                className={'text-gray-500 text-sm'}>
                                                                                {campaign[secondaryAttribute]}
                                                                                {secondaryAttributeIndex < campaignField?.secondaryAttributes?.length - 1 &&
                                                                                    <span className={'mx-1'}>|</span>
                                                                                }
                                                                            </span>
                                                                        }
                                                                    </React.Fragment>
                                                                ))}
                                                            </div>
                                                        }
                                                    </>
                                                }
                                            </td>
                                        </React.Fragment>
                                    ))}

                                    <td className="p-2 border border-gray-400 m-auto w-80">
                                        <div className="flex justify-center items-center">
                                            <div className="flex justify-around mx-1">
                                                <CopyDataToClipboard value={JSON.stringify(campaign, null, 2)}/>
                                            </div>

                                            <div className={'mx-1'}>
                                                <AddEditCampaign
                                                    isEditCampaign={true}
                                                    selectedCampaign={campaign}
                                                    refreshCampaignList={refreshCampaignList}/>
                                            </div>

                                            <GoToLink
                                                cssClass="mx-1 button-green px-2 py-1"
                                                label="Design"
                                                url={`campaigns/${campaign?.id}/design`}/>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    }
                </div>

            </div>

        </>
    )
}

export default CampaignsList
